import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import React, { useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import SimpleReactValidator from "simple-react-validator";
import { ForgotPwdEmail } from "../../Redux/Actions/webAppActions";
import { Text } from "react-internationalization";
const ForgotPwdModal = (props) => {
  const [snackBarOpen, setsnackBarOpen] = useState(false);
  const [snackBarMsg, setsnackBarMsg] = useState("");
  const [vertical, setvertical] = useState("top");
  const [horizontal, sethorizontal] = useState("center");
  // const [open,setopen]=useState(false)
  const [email, setemail] = useState("");
  const [emailError, setemailError] = useState(false);
  const [severity, setseverity] = useState("error");
  const validator = new SimpleReactValidator();
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setsnackBarOpen(false);
    setseverity("error");
  };
  const handleChange = async (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const emailError1 =
      name === "email" && (!validator.check(value, "email") || value === "");
    setemailError(emailError1);
    setemail(value);
  };
  const handleForgetPwd = async () => {
    if (emailError) {
      setsnackBarOpen(true);
      setvertical("top");
      sethorizontal("center");
      setsnackBarMsg("Please enter a valid email address.");
      return;
    }
    if (email?.trim() === "") {
      setsnackBarOpen(true);
      setsnackBarMsg("Email Address Can't Be Empty.");
      return;
    }

    const response = await props.ForgotPwdEmail(email, props?.customerId);
    if (response.message === "SUCCESS") {
      setsnackBarOpen(true);
      setseverity("success");
      setsnackBarMsg(response.data);
      setemail("");
      // props.ForgetPwdmodalClosed()
    } else {
      setsnackBarOpen(true);
      setseverity("error");
      setsnackBarMsg(response.message);
    }
  };
  return (
    <>
      <Dialog open={props.show} id={props.idName ? props.idName : ""}>
        <DialogTitle className="dialog-padding">
          {props.dialogTitle}
          {props.closeIcon ? (
            <a
              className="dialog-close"
              onClick={() => {
                setemail("");
                setsnackBarOpen(false);
                setsnackBarMsg("");
                props.ForgetPwdmodalClosed();
              }}
            >
              <i class="fas fa-times" />
            </a>
          ) : (
            ""
          )}
        </DialogTitle>
        <DialogContent>
          <Snackbar
            open={snackBarOpen}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
          >
            {
              <Alert onClose={handleClose} severity={severity}>
                {snackBarMsg}
              </Alert>
            }
          </Snackbar>
          <div class="container-Cambia container-Cambia2 mt-3 mg-footer">
            <div class="tab-content tab-content2">
              <div class="container form-panel">
                <div class="form-group">
                  <div>
                    <div>
                      <div>
                        <div className="dialog-position">
                          <TextField
                            label={<Text id="user.emailAdd" />}
                            variant="outlined"
                            type="email"
                            name="email"
                            className="dialog-field"
                            fullWidth
                            error={emailError ? true : false}
                            value={email}
                            onChange={handleChange}
                            //   onBlur={this.handleOnBlur("email")}
                            inputProps={{
                              autoComplete: "off",
                              spellcheck: "false",
                              "aria-autocomplete": "both",
                              "aria-haspopup": "false",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="button-container-login-page">
                    <div class="row justify-content-center">
                      <div>
                        <button
                          class="btn-primary-continue"
                          id="forgetPwd"
                          onClick={handleForgetPwd}
                          //    disabled={!emailError?true:false}
                        >
                          <Text id="user.reset" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    email: state.login.emailAddress,
    lang: state.webApp.language,
    successignUp: state.login.successfulSignUp,
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {
  ForgotPwdEmail,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPwdModal);
